export default __webpack_public_path__ + "files/TN_HUC8-7c3f16da6cab338dfd47676b8e961afb.pbf";